function SearchController() {
    let _searchController = this;

    _searchController.init = function () {
        // All ajax links in search
        let triggers = document.querySelectorAll('.tx_solr a.solr-ajaxified');
        Array.from(triggers).forEach(function (trigger) {
            trigger.addEventListener('click', function (event) {
                event.preventDefault();
                _searchController.handleClickOnAjaxifiedUri(event.currentTarget.href);
            })
        })

        // Search Button
        let searchButton = document.querySelector('.tx_solr button.tx-solr-submit');
        if (searchButton) {
            searchButton.addEventListener('click', event => {
                event.preventDefault();
    
                // Trigger search only if searchterm was entered
                if (document.querySelector('.tx_solr input.tx-solr-q').value) {
                    _searchController.handleClickOnAjaxifiedUri(event.currentTarget.closest('form').getAttribute('action'));
                } else {
                    document.querySelector('.tx_solr input.tx-solr-q').focus();
                }
            });
        }

        // Reset Button
        let resetButton = document.querySelector('.tx_solr button.tx-solr-reset');
        if (resetButton) {
            if (resetButton){
                resetButton.addEventListener('click', event => {
                    event.preventDefault();
                    document.querySelector('.tx_solr input.tx-solr-q').value = '';
                    _searchController.handleClickOnAjaxifiedUri(event.currentTarget.closest('form').getAttribute('action'));
                });
            }
        }
    };

    _searchController.handleClickOnAjaxifiedUri = function (url) {
        let solrContainer = document.querySelector('.tx_solr');
        let searchTerm = document.querySelector('.tx_solr input.tx-solr-q').value;

        // Display loader (book animation)
        document.querySelector('.tx_solr .tx-solr-loader').classList.toggle('hidden');

        // Prepare url
        let searchUrl = new URL(url);
        let params = new URLSearchParams(searchUrl.search); // initialize with existing search params from given url

        params.set('type', 7383);

        // Conditional params
        if (searchTerm) {
            params.set('tx_solr[q]', searchTerm);
        }

        searchUrl.search = params.toString();

        // Fetch results from endpoint
        fetch(searchUrl).then(function(response) {
            return response.text().then(function(data) {
                solrContainer.outerHTML = data;
                _searchController.init();

                // Remove type and push new search url to browser history
                let params = new URLSearchParams(searchUrl.search);
                params.delete('type');
                searchUrl.search = params.toString();
                history.replaceState({}, null, searchUrl.href);
            });
        });
    };
}

document.addEventListener('DOMContentLoaded', function () {
    let solrSearchController = new SearchController();
    solrSearchController.init();
});